module.exports = __webpack_public_path__ + "static/img/xiazailuxiang2.938bf2e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/bottom/white/xiazailuxiang2.png
// module id = l5d4
// module chunks = 24